// extracted by mini-css-extract-plugin
export default {"modalContent":"PaymentStatusModal_modalContent__jtqVU","contentWrap":"PaymentStatusModal_contentWrap__Unsfj"};